import * as React from "react";
import { useSiteData } from "../../hooks/use_site";
import UserActivityItem from "../general/user_activity_item";
import { Button } from "@mui/material";
import { CollapsableCard } from "../general/collapsable_card";

export default function ActivityCard({ tooltip, ...props }) {
  const { data: siteData, isLoading, isError } = useSiteData();
  const [count, setCount] = React.useState(4);

  const activity = siteData && siteData.changelog && siteData.changelog.sort((a, b) => b.datetime - a.datetime);

  React.useEffect(() => {
    if (activity && count > activity.length) {
      setCount(activity.length);
    }
  }, [siteData]);

  return (
    <CollapsableCard
      tooltip={tooltip}
      startCollapsed={activity && activity.length === 0}
      title={`Activity (${activity ? activity.length : "0"})`}
      width={"100%"}
      elevation={0}
      sx={props.sx}
    >
      {activity
        ? [...Array(count)].map((_, idx) => (
            <UserActivityItem isLoading={isLoading || !(idx < activity.length)} activity={activity[idx]} key={idx} />
          ))
        : null}

      {activity && activity.length - count > 0 ? (
        <Button sx={{ marginTop: 1, width: "100%" }} onClick={() => setCount(Math.min(count + 15, activity.length))}>
          View more ({activity.length - count})
        </Button>
      ) : null}
    </CollapsableCard>
  );
}
